import { render, staticRenderFns } from "./OrderReturns.vue?vue&type=template&id=55183174&"
import script from "./OrderReturns.vue?vue&type=script&lang=js&"
export * from "./OrderReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports